module.exports = __webpack_public_path__ + "media/assets/icons/home-b0326f941b5b3e1f3610df7b498b138b.svg";